import { MaybeRefOrGetter } from "vue";

import { SiteQueryKeys } from "@/data/api/site-query-keys";

export const SectionsQueryKeys = {
  all: ["query", "sections"] as const,
  appliances: (siteId: MaybeRefOrGetter<number>) =>
    [...SiteQueryKeys.sections(siteId), ...SectionsQueryKeys.all, "appliances"] as const,
  appliance: (siteId: MaybeRefOrGetter<number>, sectionId: MaybeRefOrGetter<number>) =>
    [...SectionsQueryKeys.appliances(siteId), { sectionId }] as const,
};

export const SectionsMutationKeys = {
  all: ["mutation", "sections"] as const,
  patchSection: () => [...SectionsMutationKeys.all, "section", "patch"] as const,
};
